import { createAction } from 'redux-actions';

export const setAnnotationDisplayOption = createAction(
  'SET_ANNOTATION_DISPLAY_OPTION',
);

export const resetAnnotationDisplayAndPositionOption = createAction(
  'RESET_ANNOTATION_DISPLAY_AND_POSITION_OPTION',
);

export const setWorkpaperFilterReset = createAction(
  'SET_WORKPAPER_FILTER_RESET',
);

export const resetAnnotationSidebySideView = createAction(
  'RESET_ANNOTATION_SIDEBYSIDE_VIEW',
);
